export default {
	editGuide: "Edit Relationship",
	assignGuide: "Assign Guide",
	tabs: {
		link: "Existing",
		createNew: "Create new",
	},
	filters: {
		active: "Active",
	},
};
